import type { TableColumns } from '@faceup/ui-base'
import { FuAdminRoleType } from '@faceup/utils'
import { fuAdminRoleLabels } from '../../utils/fuAdminAccess'

export const mockCredentialTableColumns: TableColumns<(typeof fuAdminsMock)[number]> = [
  {
    title: 'Email',
    dataIndex: 'email',
  },
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Roles',
    key: 'roles',
    render: record => record.roles.map(role => fuAdminRoleLabels[role]).join(', '),
  },
]

export const fuAdminsMock = [
  {
    email: 'multiple@faceup.com',
    name: 'MULTIPLE',
    roles: [FuAdminRoleType.Manager],
  },
  {
    email: 'southafrica@faceup.com',
    name: 'South Africa',
    roles: [FuAdminRoleType.Admin],
  },
  {
    email: 'superadmin@faceup.com',
    name: 'SuperAdmin',
    roles: [FuAdminRoleType.Admin],
  },
  {
    email: 'faceup@scio.cz',
    name: 'SCIO',
    roles: [FuAdminRoleType.Manager],
  },
  {
    email: 'psycholog@faceup.com',
    name: 'PSYCHOLOGIST',
    roles: [FuAdminRoleType.Psychologist],
  },
  {
    email: 'unitedstates@faceup.com',
    name: 'United States',
    roles: [FuAdminRoleType.Admin],
  },
  {
    email: 'czechia@faceup.com',
    name: 'Václav Klaus',
    roles: [FuAdminRoleType.Admin],
  },
  {
    email: 'manager-psychologist@faceup.com',
    name: 'Manager Psychologist',
    roles: [FuAdminRoleType.Manager, FuAdminRoleType.Psychologist],
  },
  {
    email: 'integration-developer@faceup.com',
    name: 'Integration Developer',
    roles: [FuAdminRoleType.IntegrationDeveloper],
  },
]
